import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import {ActionTypes} from './email-reply-actions';
import type {EmailReplyAction} from './email-reply-actions';

export type EmailReplyState = {
    isOpen: boolean;
    isMinimized: boolean;
    /**
     * True after enlarge from minimized until a new reply is opened or the modal closes.
     * Used so the composer skips passing initialValues and does not wipe the persisted draft.
     * (isMinimized is already false on the same render as enlarge, so it cannot signal this.)
     */
    pendingRestoreFromMinimize: boolean;
    replyToEmailId: string | null | undefined;
    isReplyingAll: boolean;
    onReplySuccess?: () => void;
    suggestedEmailReplyId?: string;
};

export const defaultEmailReplyState = {
    isOpen: false,
    isMinimized: false,
    pendingRestoreFromMinimize: false,
    replyToEmailId: null,
    isReplyingAll: false,
} as const;

export const emailReplyReducer = (
    state: EmailReplyState | null | undefined = defaultEmailReplyState,
    action: EmailReplyAction
): EmailReplyState => {
    const prev: EmailReplyState = state ?? defaultEmailReplyState;

    switch (action.type) {
        case ActionTypes.EMAIL_REPLY_OPENED:
            return {
                ...prev,
                isOpen: true,
                isMinimized: false,
                pendingRestoreFromMinimize: false,
                replyToEmailId: action.payload.replyToEmailId,
                isReplyingAll: action.payload.isReplyingAll,
                onReplySuccess: action.payload.onReplySuccess,
                suggestedEmailReplyId: action.payload.suggestedEmailReplyId,
            };
        case ActionTypes.EMAIL_REPLY_MINIMIZED:
            return {
                ...prev,
                isOpen: false,
                isMinimized: true,
            };
        case ActionTypes.EMAIL_REPLY_ENLARGED:
            return {
                ...prev,
                isOpen: true,
                isMinimized: false,
                pendingRestoreFromMinimize: true,
            };
        case ActionTypes.EMAIL_REPLY_CLOSED:
            return defaultEmailReplyState;
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            const persistedState = action.payload;
            if (!persistedState || !persistedState.ui || !persistedState.ui.emailReplyModal) {
                // @ts-expect-error
                return state;
            }

            return persistedState.ui.emailReplyModal;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
